var _desc, _defs, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComparisonIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.5.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "rgba(255,255,255,0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(33.2364 0 0 33.2364 472.0922 493.0224)",
    id: 418322
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -6.35 0.85)",
    id: "pictogram"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-17.65, -24.85)",
    d: "M 20.6 28.9 l -1.4 1.4 l 2.3 2.3 h -6.8 V 17.2 c 1.1 -0.4 2 -1.5 2 -2.8 c 0 -1.6 -1.3 -3 -3 -3 s -3 1.3 -3 3 c 0 1.3 0.8 2.4 2 2.8 v 16.4 l 1 1 h 7.8 l -2.3 2.3 l 1.4 1.4 l 4 -4 v -1.4 L 20.6 28.9 z M 13.7 13.4 c 0.5 0 1 0.4 1 1 c 0 0.5 -0.4 1 -1 1 c -0.5 0 -1 -0.4 -1 -1 C 12.7 13.9 13.2 13.4 13.7 13.4 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 6.35 -0.85)",
    id: "pictogram"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-30.35, -23.15)",
    d: "M 27.4 19.1 l 1.4 -1.4 l -2.3 -2.3 h 6.8 v 15.4 c -1.1 0.4 -2 1.5 -2 2.8 c 0 1.6 1.3 3 3 3 s 3 -1.3 3 -3 c 0 -1.3 -0.8 -2.4 -2 -2.8 V 14.4 l -1 -1 h -7.8 l 2.3 -2.3 l -1.4 -1.4 l -4 4 v 1.4 L 27.4 19.1 z M 34.3 34.6 c -0.5 0 -1 -0.4 -1 -1 c 0 -0.5 0.4 -1 1 -1 c 0.5 0 1 0.4 1 1 C 35.3 34.1 34.8 34.6 34.3 34.6 z",
    strokeLinecap: "round"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComparisonIcon);
export default __webpack_public_path__ + "static/media/comparison-icon.01cc1a8ae7244f5e33e0625f56573500.svg";
export { ForwardRef as ReactComponent };